module.exports = __webpack_public_path__ + "media/customizations/unionparklife/logo-7d696c3aee35256cf5ba6993cb6e31f1.png";